var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function area"
  }, [_vm._m(0), _c("section", {
    staticClass: "product-function__introduction"
  }, [_c("Skill", {
    attrs: {
      skillList: _vm.skillList
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-function__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("FUNCTION")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("功能介绍")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };